import axios from "axios";
import {config} from "@/config";

export async function makeRequest(method, uri, data, headers) {
    return await axios.create({
        validateStatus: () => true // Prevent axios from throwing Promise exception, so it can be handled in operation.checkResponse().
    }).request({
        method: method,
        url: config.serverUrl + uri,
        data: data,
        headers: headers
    });
}

export async function makeRequestBlob(method, uri, data, headers) {
    return await axios.create({
        validateStatus: () => true
    }).request({
        method: method,
        url: config.serverUrl + uri,
        responseType: 'blob',
        data: data,
        headers: headers
    });
}

export async function makeRequestToGraduatesBackend(method, uri, data, headers) {
    return await axios.create({
        validateStatus: () => true
    }).request({
        method: method,
        url: config.graduatesBackendUrl + uri,
        data: data,
        headers: headers
    });
}

export async function makeRequestToGraduatesBackendBlob(method, uri, data, headers) {
    return await axios.create({
        validateStatus: () => true
    }).request({
        method: method,
        url: config.graduatesBackendUrl + uri,
        responseType: 'blob',
        data: data,
        headers: headers
    });
}
